<section class="dalel-page" dir="rtl">
  <div class="page-hero">
    <div class="shell">
      <p class="page-kicker">دليل بلس</p>
      <h1>أحكام وشروط</h1>
    </div>
  </div>
  <div class="page-body shell">
    <ol>
      <li>
        <h2>المادة الأولى: تعريفات</h2>
        <p>
          • منصة دليل: هي منصة إلكترونية تتيح للمستخدمين فتح حسابات لنشر المحتوى وفقًا للأنظمة والتشريعات.
          <br />• المستخدم: هو الشخص الذي ينشئ حسابًا على المنصة لغرض التواصل أو نشر المحتوى أو تقديم الخدمات.
          <br />• المحل الإلكتروني: هو الحساب الإلكتروني الذي يتيح للمستخدم عرض أو بيع منتج أو تقديم خدمة.
        </p>
      </li>
      <li>
        <h2>المادة الثانية: شروط الاستخدام</h2>
        <p>
          • عدم نشر محتوى غير ملائم للتصنيفات المتاحة.
          <br />• عدم اختراق أو التحايل على قوانين وسياسات المنصة.
          <br />• عدم نسخ الإعلانات من المنصة وإعادة نشرها في مواقع أخرى.
          <br />• عدم استخدام وسائل غير شرعية للوصول إلى بيانات المستخدمين الآخرين.
          <br />• الالتزام بالضوابط والتراخيص الصادرة من الجهات المختصة عند تقديم عروض أو منتجات معينة.
        </p>
      </li>
      <li>
        <h2>المادة الثالثة: المسؤولية</h2>
        <p>توضح هذه المادة مسؤولية مؤسسة موقع دليل لتقنية المعلومات والمستخدمين فيما يتعلق باستخدام المنصة.</p>
      </li>
      <li>
        <h2>المادة الرابعة: الشروط والأحكام العامة</h2>
        <p>تشمل هذه المادة بنودًا إضافية تتعلق بسياسات المنصة والتزامات المستخدمين.</p>
      </li>
      <li>
        <h2>المادة الخامسة: حقوق الملكية الفكرية</h2>
        <p>تؤكد هذه المادة على حقوق الملكية الفكرية للمحتوى الموجود على المنصة.</p>
      </li>
      <li>
        <h2>المادة السادسة: سياسة الخصوصية</h2>
        <p>توضح هذه المادة كيفية تعامل المنصة مع البيانات الشخصية للمستخدمين.</p>
      </li>
      <li>
        <h2>المادة السابعة: الرسوم والاشتراكات</h2>
        <p>تحدد هذه المادة الرسوم المستحقة للمنصة مقابل الخدمات المقدمة.</p>
      </li>
      <li>
        <h2>المادة الثامنة: إنهاء الاتفاقية</h2>
        <p>توضح هذه المادة الحالات التي يمكن فيها إنهاء الاتفاقية بين المنصة والمستخدم.</p>
      </li>
      <li>
        <h2>المادة التاسعة: التواصل</h2>
        <p>تحدد هذه المادة وسائل التواصل المعتمدة بين المنصة والمستخدمين.</p>
      </li>
      <li>
        <h2>المادة العاشرة: أحكام عامة</h2>
        <p>
          تشمل هذه المادة بنودًا عامة تتعلق بتفسير وتطبيق الاتفاقية.
          <br /><br />
          يُنصح بمراجعة هذه البنود بما يتناسب مع طبيعة موقعك والتشريعات المحلية المعمول بها، لضمان الامتثال القانوني وحماية حقوق جميع الأطراف.
        </p>
      </li>
    </ol>
  </div>
</section>
